module.exports = __webpack_public_path__ + "static/media/offline-deposit.9e85f8c7.svg";